export const CV_CONTAINER_ID = 'cv'
